const ID_SEGMENT_PATTERNS: readonly RegExp[] = [
  // Prefixed ids, ie. offi_f659a645-6b01-4744-bf11-dec18b6427cf
  /^[a-z]+_[0-9a-f-]{8,}$/i,
  // Bare uuids
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  // Numeric ids
  /^\d+$/,
  // Emails
  /^[^@\s]+@[^@\s]+$/,
  // Dates, ie. 2026-10-26 or 2026-10-26T09:01:10.933Z
  /^\d{4}-\d{2}-\d{2}(T.*)?$/
];

/**
 * Turns a request url into the endpoint it hit, without ids or query string,
 * so failures of the same endpoint can be grouped together.
 *
 * @example
 * endpointTemplate("/v1/offices/offi_f659a645-6b01-4744-bf11-dec18b6427cf/resources?date=1")
 * // => "/v1/offices/:id/resources"
 */
export function endpointTemplate(url: string): string {
  const path = url.replace(/^[a-z]+:\/\/[^/]+/i, "").split(/[?#]/)[0] ?? "";
  return path
    .split("/")
    .map((segment) => {
      const decoded = safeDecode(segment);
      return ID_SEGMENT_PATTERNS.some((pattern) => pattern.test(decoded))
        ? ":id"
        : segment;
    })
    .join("/");
}

function safeDecode(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
